import { useEffect } from 'react'
import { useNinetailed } from '@ninetailed/experience.js-react'
import { getBrowserName, getOs } from '@/utils/user-info'
export default function TrackPage() {
  const { page, identify } = useNinetailed()

  useEffect(() => {
    if (typeof window.ninetailed !== 'undefined') {
      page()
      identify('', { browser: getBrowserName(), os: getOs() })

      let intervalId

      const checkForClearbitData = () => {
        const clearbitData = window.dataLayer?.find((item) => item['1'] === 'user_properties')
        if (clearbitData?.[2]) {
          identify('', clearbitData[2])
          if (intervalId) {
            clearInterval(intervalId)
          }
        }
      }

      // poll dataLayer clearbit
      if (window.dataLayer) {
        intervalId = setInterval(() => {
          checkForClearbitData()
        }, 20)

        setTimeout(() => {
          if (intervalId) {
            clearInterval(intervalId)
          }
        }, 500)
      }
      checkForClearbitData()
    }
  }, [page])

  return null
}
